import $ from 'jquery';
import React, { Fragment, useState, useContext } from 'react';
import { createPortal } from 'react-dom';
import { PageStateContext } from '../../context/PageStateContext';

import CreateFromTemplateModal from '../templates/CreateFromTemplateModal';

import { getApiTemplateUrl } from '../../utilities/urlHelper';

export default (props) => {
    const [showModal, setShowModal] = useState(false);
    const { pageState, setPageState } = useContext(PageStateContext);

    const openModal = () => setShowModal(true);

    const closeModal = () => setShowModal(false);

    const selectTemplate = (templateId) => {
        closeModal();
        const url = getApiTemplateUrl(templateId);
        $.get(url).then(({ page: template }) => setPageState({ ...pageState, template }));
    };

    return (
        <Fragment>
            <span className="create-from-template-modal-link dropdown-option blue" onClick={openModal}>Start from template</span>
            { showModal && createPortal(<CreateFromTemplateModal closeModal={closeModal} selectTemplate={selectTemplate} />, document.body) }
        </Fragment>
    );
};
